import DefaultDescription from './DefaultDescription';

export default DefaultDescription;
